export default "__VITE_ASSET__BnHXgozR__"